var _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 720 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#da121a",
    height: 360,
    width: 720
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fcdd09",
    height: 240,
    width: 720
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#078930",
    height: 120,
    width: 720
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,180)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#0f47af",
    r: 120
  }), /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcdd09",
    d: "M0,-96 -4.205849,-83.055728 13.141645,-29.665631H-9.987258L-12.586616,-21.665631H61.576052L72.587108,-29.665631H21.553343z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fcdd09",
    strokeWidth: 4,
    d: "M0,44V96",
    transform: "rotate(216)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "rotate(216)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "rotate(288)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEt);
export default __webpack_public_path__ + "static/media/et.fd66504709c1d95041b5aaf51bd0995b.svg";
export { ForwardRef as ReactComponent };